export function chessPlayerBirthLabel(player) {
  if (player?.birth_date) {
    const [year, month, day] = player.birth_date.split("-");
    return `Geb. ${day}.${month}.${year}`;
  }
  return player?.birth_year ? `Jahrgang ${player.birth_year}` : "";
}
